import jQuery from 'jquery';
import URI from 'urijs';

function numFormatter(num){
	num = num.toString().replace(/\$|\,/g,'');
	if(isNaN(num)){
		num = "0";
	}
	var sign = (num == (num = Math.abs(num)));
	num = Math.floor(num*100);
	var cents = num%100;
	num = Math.floor(num/100).toString();
	if(cents<10){
		cents = "0" + cents;
	}
	for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
		num = num.substring(0,num.length-(4*i+3))+'.'+
		num.substring(num.length-(4*i+3));
	
	return (((sign)?'':'-') + num + ',' + cents);
}

function currencyFormatter(num, reverse){
	if(reverse){
		return numFormatter(num) + ' €';
	}else{
		return '€ ' + numFormatter(num);
	}
}

function percentFormatter(num){
	return numFormatter(num) + '%';
}

function headerRenderer(initialized, calculations, validationErrors, rendererSettings){
	if(!initialized){
		this._headerWrapper = jQuery(
				'<div class="commerz-finanz-header-wrapper">' +
					'<h2 class="commerz-finanz-title">Ratenrechner</h2>' +
				'</div>'
			);
		
		this._inputWrapperElement = jQuery('<div class="commerz-finanz-input-wrapper"></div>');
		this._inputElement = jQuery('<input class="commerz-finanz-input" type="number" name="commerz-finanz-instalment" step="0.01" min="0.01" /> ');
		this._inputErrorsElement = jQuery('<ul class="commerz-finanz-input-errors"></ul>');
		this._inputErrorsElement.hide();
		
		this._inputRowWrapperElement = jQuery(
				'<div class="commerz-finanz-input-row-wrapper">' +
					'<label class="commerz-finanz-input-label">Gesamtbestellwert</label>' +
				'</div>');
		this._inputRowWrapperElement
			.append(this._inputElement).
			append(this._inputErrorsElement);
		
		this._inputWrapperElement
			.append(this._inputRowWrapperElement);
		
		var element = this.element;
		var updateFunction = function(){
			var value = jQuery(this).val();
			
			element.commerzFinanzRatenrechner('option', 'financedAmount', value);
		};
		
		this._inputElement.on('keyup', updateFunction);
		this._inputElement.on('change', updateFunction);
		
		element
			.append(this._headerWrapper)
			.append(this._inputWrapperElement);
	}
	
	var inputErrorsElement = this._inputErrorsElement;
	inputErrorsElement.empty();
	jQuery.each(validationErrors, function(idx, validationError){
		var errorElement= jQuery('<li>' + validationError + '</li>');
		inputErrorsElement.append(errorElement);
	});
	
	if(validationErrors.length === 0){
		inputErrorsElement.hide();
		
		this._inputElement.val(this.options.financedAmount);
	}else{
		inputErrorsElement.show();
	}
}

function bodyRenderer(initialized, calculations, validationErrors, rendererSettings){
	if(!initialized){
		this._wrapperElement = jQuery('<div class="commerz-finanz-wrapper invalid"></div>');
		
		const runningTimesElm = jQuery('<div class="running-times"></div>');
		this._wrapperElement.append(runningTimesElm);
		this._runningTimesElm = runningTimesElm;
		
		const runningTimesLabel = jQuery('<div class="running-times-label">Laufzeit in Monaten:</div>');
		runningTimesElm.append(runningTimesLabel);
		
		const runningTimesList = jQuery('<ul class="running-times-list"></ul>');
		runningTimesElm.append(runningTimesList);
		this._runningTimesList = runningTimesList;
		
		const calculationsList = jQuery('<div class="calculations-list"></div>');
		this._calculationsList = calculationsList;
		this._wrapperElement.append(calculationsList);
		
		this.element.append(this._wrapperElement);
	}else{
		var inputWrapperElement = this._inputWrapperElement;
		var wrapperElement = this._wrapperElement;
		
		const runningTimesList = this._runningTimesList;
		if(calculations.length === 0){
			wrapperElement.addClass('invalid');
			this._calculationItems = [];
		}else{
			this._runningTimesElm.find('.running-time-btn').off();
			runningTimesList.children().remove();
			this._calculationsList.children().remove();
			
			let selectedCalculation = calculations[0];
			jQuery.each(calculations, function(index, calculation){
				if(calculation.interest < selectedCalculation.interest || (calculation.interest === selectedCalculation.interest && calculation.runningTime > selectedCalculation.runningTime)){
					selectedCalculation = calculation;
				}
			});
			
			
			const configuredCurrencyFormatter = rendererSettings.currencyFormatter;
			const configuredPercentFormatter = rendererSettings.percentFormatter;
			
			const calculationItems = [];
			jQuery.each(calculations, function(index, calculation){
				const calculationItem = jQuery('<div class="calculation-item"></div>');
				if(selectedCalculation !== calculation){
					calculationItem.hide();
				}
				
				const instalmentItem = jQuery('<div class="instalment"></div>');
				instalmentItem.text('Monatliche Rate: ');
				
				const instalmentValueItem = jQuery('<span class="instalment-value"></div>');
				instalmentValueItem.text(configuredCurrencyFormatter(calculation.instalment));
				instalmentItem.append(instalmentValueItem);
				
				calculationItem.append(instalmentItem);
				
				const interestItem = jQuery('<div class="interest"></div>');
				interestItem.text('Sollzins (jährl., gebunden): ' + configuredPercentFormatter(calculation.interest));
				calculationItem.append(interestItem);

				const yearInterestItem = jQuery('<div class="year-interest"></div>');
				yearInterestItem.text('Effektiver Jahreszins: ' + configuredPercentFormatter(calculation.yearInterest));
				calculationItem.append(yearInterestItem);
				
				const totalAmountItem = jQuery('<div class="total-amount"></div>');
				totalAmountItem.text('Gesamtbetrag: ' + configuredCurrencyFormatter(calculation.totalAmount));
				calculationItem.append(totalAmountItem);
				
				calculationItems.push(calculationItem);
			});
			
			this._calculationsList.append(calculationItems);
			
			const runningTimesItems = [];
			jQuery.each(calculations, function(index, calculation){
				const runningTimeBtn = jQuery('<button type="button" class="running-time-btn"></button');
				runningTimeBtn.text(calculation.runningTime);
				runningTimeBtn.on('click', function(){
					const elm = jQuery(this);
					const parent = elm.parent();
					parent.siblings().removeClass('selected');
					parent.addClass('selected');
					
					jQuery.each(calculationItems, function(calculationItemIndex, calculationItem){
						const calculationItemElm = jQuery(calculationItem);
						
						if(calculationItemIndex === index){
							calculationItemElm.show()
						}else{
							calculationItemElm.hide();
						}
					});
				});
				
				const runningTimesItem = jQuery('<li class="running-time"></li>');
				runningTimesItem.append(runningTimeBtn);
				
				if(calculation === selectedCalculation){
					runningTimesItem.addClass('selected');
				}
				
				runningTimesItems.push(runningTimesItem);
			});
			
			runningTimesList.append(runningTimesItems);
			
			wrapperElement.removeClass('invalid');
		}
	}
}

function renderer(calculations, rendererSettings, validationErrors){
	rendererSettings.beforeRenderListener.apply(this, [calculations]);
	
	//Prepare render cycle
	if(typeof this._rendererInitialized === 'undefined'){
		rendererSettings.headerRenderer.apply(this, [false, calculations, validationErrors, rendererSettings]);
		rendererSettings.bodyRenderer.apply(this, [false, calculations, validationErrors, rendererSettings]);
		
		this._rendererInitialized = true;
	}	
	
	//Render
	rendererSettings.headerRenderer.apply(this, [true, calculations, validationErrors, rendererSettings]);
	rendererSettings.bodyRenderer.apply(this, [true, calculations, validationErrors, rendererSettings]);
	
	rendererSettings.afterRenderListener.apply(this, [calculations]);
}

var financedAmountValidator = function(financedAmount, validatorSettings){
	var errors = [];
	
	var currencyFormatter = validatorSettings.currencyFormatter;
	
	if(
		financedAmount !== undefined && (
				!jQuery.isNumeric(financedAmount) ||
				financedAmount < validatorSettings.minFinancedAmount ||
				financedAmount > validatorSettings.maxFinancedAmount
			)
	){
		errors.push('Bitte geben Sie einen Betrag zwischen ' + currencyFormatter(validatorSettings.minFinancedAmount)  + ' und ' + currencyFormatter(validatorSettings.maxFinancedAmount)  + ' ein.');
	}
	
	return errors;
};

var calculator = function(runningTimes, financedAmount, calculatorSettings){
	var zeroPercentUntilRunningTime = calculatorSettings.zeroPercentUntilRunningTime;
	var interest = calculatorSettings.interest;
	var minInstalment = calculatorSettings.minInstalment;
	
	var calculations = [];
	
	if(typeof financedAmount === 'undefined'){
		return calculations;
	}
	
	jQuery.each(runningTimes, function(index, runningTime){
		const isZeroPercent = (typeof zeroPercentUntilRunningTime === 'undefined') || (runningTime <= zeroPercentUntilRunningTime);
		//const isZeroPercent = false;

		let instalment = null;
		let calcInterest = null;
		let calcYearInterest = null;
		let totalAmount = null;
		
		if(isZeroPercent){
			instalment = (financedAmount/runningTime);
			calcInterest = 0;
			calcYearInterest = 0;
			totalAmount = financedAmount;
		}else{
			var interestPercent = interest*10;
			calcInterest =  Math.floor((Math.pow((1+interestPercent/10/100),(1/12))-1)*12*100*100)/100;
			instalment = financedAmount*Math.pow((Math.pow((interestPercent/10/100+1),(1/12))),runningTime)/((Math.pow(((Math.pow((interestPercent/10/100+1),(1/12)))),runningTime))-1)*((Math.pow((interestPercent/10/100+1),(1/12)))-1);
			calcYearInterest = interest;
			totalAmount = Math.floor((financedAmount*Math.pow((Math.pow((interestPercent/10/100+1),(1/12))),runningTime)/((Math.pow(((Math.pow((interestPercent/10/100+1),(1/12)))),runningTime))-1)*((Math.pow((interestPercent/10/100+1),(1/12)))-1))*100)/100*runningTime;
		}
		
		if(instalment >= minInstalment){
			calculations.push({
				runningTime: runningTime,
				instalment: instalment,
				interest: calcInterest,
				yearInterest: calcYearInterest,
				totalAmount: totalAmount
			});
		}
	});
	return calculations;
};

jQuery.widget('kps.commerzFinanzRatenrechner', {
	options: {
		renderer: renderer,
		rendererSettings: {
			currencyFormatter: currencyFormatter,
			percentFormatter: percentFormatter,
			afterRenderListener: function(calculations){},
			beforeRenderListener: function(calculations){},
			headerRenderer: headerRenderer,
			bodyRenderer: bodyRenderer
		},
		calculator: calculator,
		calculatorSettings: {
			zeroPercentUntilRunningTime: 1,
			interest: 9.9,
			minInstalment: 9,
			maxRunningTime: 40
		},
		financedAmountValidator: financedAmountValidator,
		financedAmountValidatorSettings: {
			minFinancedAmount: 200,
			maxFinancedAmount: 14999.99,
			currencyFormatter: numFormatter,
		},
		runningTimeFn: function(prevRunningTime){
			const runningTimeStep = 2;
			
			let runningTime;
			if(typeof prevRunningTime === 'undefined'){
				runningTime = 6;
			}else if(prevRunningTime === 6){
				runningTime = 8;
			}else{
				runningTime = prevRunningTime + runningTimeStep;
			}
			
			return runningTime;
		},
		financedAmount: undefined,
	},
	_create: function() {
		this._validationErrors = [];
		
		if(typeof this.options.financedAmount === 'undefined'){
			const uri = new URI();
			const query = URI.parseQuery(uri.query());
			if(typeof query.cfv !== 'undefined'){
				this._setOption('financedAmount', query.cfv);
			}
		}
		
		this.refresh();
	},
	_setOption: function( key, value ) {
		if ( key === 'financedAmount' ) {
			value = parseFloat(value);
			
			if(value === this.options.financedAmount){
				return;
			}
			
			var financedAmountValidatorSettings = this.options.financedAmountValidatorSettings;
			var validationErrors = this.options.financedAmountValidator.apply(this, [value, financedAmountValidatorSettings]);
			if(validationErrors.length !== 0){
				value = undefined;
				this._validationErrors = validationErrors;
			}else{
				this._validationErrors = [];
			}
		}
		jQuery.Widget.prototype._setOption.apply(this, [key, value]);
		this.refresh();
	},
	_setOptions: function(options) {
		jQuery.Widget.prototype._setOptions.apply(this, [options]);
	},
	refresh:function(){
		const runningTimes = this._getRunningTimes();
		
		var calculations = this.options.calculator.apply(this, [
			runningTimes,
			this.options.financedAmount,
			this.options.calculatorSettings,
		]);
		
		this.options.renderer.apply(this, [
			calculations,
			this.options.rendererSettings,
			this._validationErrors
		]);
	},
	_getRunningTimes: function(){
		const runningTimes = [];
		
		const runningTimeFn = this.options.runningTimeFn;
		const maxRunningTime = this.options.calculatorSettings.maxRunningTime;
		
		let runningTime = undefined;
		while(true){
			runningTime = runningTimeFn(runningTime);
			if(runningTime > maxRunningTime){
				break;
			}else{
				runningTimes.push(runningTime);
			}
		}
		
		return runningTimes;
	}
});

export default function(){
	jQuery(function(){
		jQuery('.commerz-finanz-ratenrechner-widget').commerzFinanzRatenrechner();
	});
}
